<template>
  <div class="container-not-found">
    <div class="cover">
      <img src="@/assets/images/page_not_found.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page-Not-Found'
}
</script>

<style lang="scss" scoped>
.container-not-found{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  .cover {
    height: 400px;
    img {
      height: 100%;
    }
  }
}
</style>
